<div class="nav-items">
  @for (item of navService.navItems; track item) {
    @let isNavVisible = navService.isSportVisible(item.name.toLowerCase(), "header") | async;
    @if (isNavVisible) {
      @if (item.name === "Casino") {
        <a (click)="navService.openCasino()" class="nav-item header-tab" target="_blank">
          <mat-icon>{{ getNavIcon(item.name) }}</mat-icon>
          <span>{{ item.name | translate }}</span>
        </a>
      } @else if (item.name === "Home") {
        @if (displayModeService.mode() !== 'LEAGUE-WISE') {
          <a
            routerLinkActive="header-tab-active is-active-tab"
            [routerLink]="item.path"
            class="nav-item header-tab"
            (click)="goHomeDefaultSport($event)"
            [routerLinkActiveOptions]="{ exact: false }">
            <mat-icon>{{ getNavIcon(item.name) }}</mat-icon>
            <span>{{ item.name | translate }}</span>
          </a>
        }
      } @else {
        <a routerLinkActive="header-tab-active is-active-tab" [routerLink]="item.path" class="nav-item header-tab">
          <mat-icon>{{ getNavIcon(item.name) }}</mat-icon>
          <span>{{ item.name | translate }}</span>
        </a>
      }
    }
  }
</div>

<app-m-header />